import Cookies from 'js-cookie';
import queryString from 'query-string';

import {
	loadFromSessionStorage,
	saveToSessionStorage,
	ssKeys,
} from '~features/storage';
import { LoggerMessages } from '~logger/constants';
import { sendMetricToAPI } from '~shared/services/metrics/sendMetricToAPI';

import { allowedMarkers } from './markerKeys';

//Logic copied from landing
//the idea is to gather markers from all available sources on site entry
//then markers should be sent during registration if occurs
class Markers {
	private allowedMarkers = allowedMarkers;
	private readonly hash: Record<string, unknown> = {};
	private readonly search: Record<string, unknown> = {};
	private readonly session: Record<string, string> = {};
	private responseMarkers: Record<string, unknown> = {};
	private readonly pathWithMarkers: string | undefined;

	constructor() {
		if (typeof window !== 'undefined') {
			this.hash = queryString.parse(window.location.hash);
			this.search = queryString.parse(window.location.search);
			this.session = loadFromSessionStorage(ssKeys.MARKERS, {}) as Record<
				string,
				string
			>;

			this.pathWithMarkers = document.location.href;
			this.init();
		}
	}

	private getCookieMarkers = () => {
		const cookies = Cookies.get();
		return Object.fromEntries(
			Object.entries(cookies).filter(([key]) => {
				return allowedMarkers.includes(key);
			})
		);
	};

	init = () => {
		if (Object.keys(this.session).length > 0) {
			this.responseMarkers = {
				...this.getCookieMarkers(),
				...this.session,
			};
			return;
		}
		this.allowedMarkers.forEach((marker) => {
			Object.entries(this.getCookieMarkers()).forEach(([key, value]) => {
				this.responseMarkers[key] = value;
			});
			if (this.hash[marker]) {
				this.responseMarkers[marker] = this.hash[marker];
				return;
			}
			if (this.search[marker]) {
				let value: unknown = this.search[marker];
				if (Array.isArray(value)) {
					value = value[0];
				}

				this.responseMarkers[marker] = value;
				return;
			}

			if (document[marker as keyof Document] && !this.responseMarkers[marker]) {
				this.responseMarkers[marker] = document[marker as keyof Document];
			}
		});

		void sendMetricToAPI(
			{
				name: `markers.init.fresh`,
				tags: Object.keys(this.responseMarkers),
				raw: {
					responseMarkers: this.responseMarkers,
				},
			},
			LoggerMessages.MetricMarkersFailed
		);

		return saveToSessionStorage(ssKeys.MARKERS, this.responseMarkers);
	};

	getMarkersRegistration = () => {
		this.init();
		return {
			...this.responseMarkers,
			referrer:
				this.responseMarkers.referrer ||
				document.referrer ||
				window.location.href,
			emguid: 0,
			tracker: null,
		} as unknown as Record<string, string>;
	};

	getMarkersAnnals = () => {
		return {
			link: document.location.origin + document.location.pathname,
			link_full: this.getFullPathWithMarkers(),
			AFID: this.responseMarkers['afid'],
			StageName: this.responseMarkers['utm_source'],
			Campaign: this.responseMarkers['utm_campaign'],
		};
	};

	clearMarkers = () => {
		return saveToSessionStorage(ssKeys.MARKERS, {});
	};

	getFullPathWithMarkers = () => {
		return this.pathWithMarkers;
	};
}

export const MarkersService = new Markers();
